import React from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import { Container } from 'react-bootstrap';
import './GiftCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGift } from '@fortawesome/free-solid-svg-icons';

const GiftCard = () => {
    return (
        <div>
            <Header></Header>
            <div className="gift-bg">
                <div className="col-11 mx-auto d-lg-flex flex-column justify-content-center align-items-center gift-card">
                    <h1 className="text-white fw-bold">Who says you can’t buy happiness?
                    </h1>
                    <p className="text-white">Take your loved ones to their happy place with a 500 Degrees Gift Card.
                    </p>
                    <a target="_blank" href="https://squareup.com/gift/MLVGE4795QQXC/order">
                        <button className="btn btn-warning mt-2 mt-lg-0 me-lg-2" style={{
                            width: '155px'
                        }}>
                            <FontAwesomeIcon icon={faGift} />
                            <span className="ms-2">
                                Gift Card
                            </span>
                        </button>
                    </a>
                </div>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default GiftCard;